import React, { Component } from 'react';
import { supplierProductLink, supplierName } from '../../helpers/suppliers';
import { formatIntCurrency } from '../../helpers/format';
import { qohTag, supplierPriceTag } from './tags';
import { Hit } from '../../rpc/admin/search_pb';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';

class SimilarProps {
    hits?: Hit[];
    price: number = 0;
    qoh: number = 0;
}

class SimilarState {}

class Similar extends Component<SimilarProps & RouteComponentProps<any>, SimilarState> {

    render() {
        if (!this.props.hits?.length) {
            return <></>;
        }

        return (
            <div className="columns">
                <div className="column">
                    <h3 className="product-group is-size-5 has-text-weight-bold">Similar Items</h3>
                    <table className="table is-full-width">
                        <thead>
                            <tr>
                                <th className="product-supplier-name">Supplier</th>
                                <th>Product</th>
                                <th>QOH</th>
                                <th className="product-supplier-price">Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.hits.map(product => {
                                return (
                                    <tr key={product.getSupplier() + product.getSku()}>
                                        <td className="product-supplier-name">
                                            <Link to={supplierProductLink(product.getSupplier(), product.getSku())}>
                                                {supplierName(product.getSupplier())}
                                            </Link>
                                        </td>
                                        <td>{product.getName()}</td>
                                        <td>
                                            <span className={qohTag(product.getSupplier(), this.props.qoh!, this.props.hits!)}>{product.getQoh()}</span>
                                        </td>
                                        <td className="product-supplier-price">
                                            <span className={supplierPriceTag(product.getSupplier(), this.props.price, this.props.hits!)}>{formatIntCurrency(product.getPrice())}</span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default withRouter(Similar);
